import { OnInit } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service';
import { merge, fromEvent } from 'rxjs';
import { Router } from '@angular/router';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { detailFromBreadcrumb, normalizePath } from '@app/shared/utils';
var SearchResultItemComponent = /** @class */ (function () {
    function SearchResultItemComponent(authService, _window, router, itauUserIdleService, sessionService, _sdkAnalyticsService) {
        this.authService = authService;
        this._window = _window;
        this.router = router;
        this.itauUserIdleService = itauUserIdleService;
        this.sessionService = sessionService;
        this._sdkAnalyticsService = _sdkAnalyticsService;
    }
    SearchResultItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    };
    SearchResultItemComponent.prototype.redirectPage = function (event) {
        var nameEvent;
        if (event && event.__proto__ && event.__proto__.constructor.name) {
            nameEvent = event.__proto__.constructor.name;
        }
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            nameEvent = event.type;
        }
        if (nameEvent && (nameEvent === 'MouseEvent' || nameEvent === 'click' || nameEvent === 'PointerEvent' || nameEvent === 'KeyboardEvent') && this.typeMenu !== 5) {
            this.itauUserIdleService.stopWatching();
            this.sessionService.updateSession().subscribe(function () { });
            var sUrl = this.authUser.serverEstatisticas + '?xyz=0';
            if (this.description && this.router && this.router.url) {
                this._sdkAnalyticsService.trackEvent('click', {
                    custom_path: normalizePath(this.router.url),
                    implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                    detail: detailFromBreadcrumb(this.description, 'resultado-busca:')
                });
            }
            try {
                var userType = this.authUser.tipo == 1 ? "A" : "C";
                sUrl += this.getQueryString(this.authUser.token, this.authUser.idSessao, this.authUser.idConexao, this.authUser.gestor, this.authUser.name, userType);
                sUrl += this.getQueryStringFunction(this.id);
                var windowOK4 = this._window.open(sUrl, name, 'directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5');
                this.itauUserIdleService.setCustomActivityEvents(merge(fromEvent(window, 'mousemove'), fromEvent(window, 'resize'), fromEvent(document, 'keydown'), fromEvent(document, 'touchstart'), fromEvent(document, 'touchend'), fromEvent(windowOK4, 'mousemove'), fromEvent(windowOK4, 'resize')));
                this.itauUserIdleService.startWatching();
            }
            catch (ex) {
                throw ex;
            }
        }
        else {
            this.openModalContext(this.url);
        }
    };
    SearchResultItemComponent.prototype.openModalContext = function (myurl) {
        if (this.description && myurl) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(myurl),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: detailFromBreadcrumb(this.description, 'resultado-busca:')
            });
        }
        this.router.navigate([myurl]);
    };
    SearchResultItemComponent.prototype.getQueryStringFunction = function (codFunction) {
        try {
            return '&iDFuncao=' + (-1 * codFunction);
        }
        catch (ex) {
            throw ex;
        }
    };
    SearchResultItemComponent.prototype.getQueryString = function (token, idConnection, idSession, sGestor, nameUser, userType) {
        try {
            return '&sessao=' + token +
                '&id=' + idConnection +
                '&idsessao=' + idSession +
                '&gestor=' + sGestor +
                '&nomeUsu=' + nameUser +
                '&tipousu=' + userType;
        }
        catch (ex) {
            throw ex;
        }
    };
    return SearchResultItemComponent;
}());
export { SearchResultItemComponent };
